import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AdvertiseComp from "../../components/Advertisement/AdvertiseComp";
import PopupComponent from "../../components/PopupConfig/PopupComponent";

const PopupConfiguration = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Popup Configuration' />

                {/* GalleryLayer */}
                <PopupComponent />
            </MasterLayout>
        </>
    );
};

export default PopupConfiguration;
